import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { WhatsAppConversation } from "../../aiConversations.types";
import { ApiRoutesAiConversations } from "../../constants/enums";

export const requestGetConversation = async (
  conversationId: string
): Promise<WhatsAppConversation> => {
  return await instance.get(
    buildUrl(ApiRoutesAiConversations.Conversations, conversationId)
  );
};
